import { CountryCodes } from "../../constants/countries";
import { IAddressCheckin, IPhoneCheckin } from "../../dtos/KioskDtos.dtos";

export class PatientDefault {
    public readonly newEmail = {
        address: "",
        contactPointId: "",
        isOkToContact: false,
        contactPointType: "Personal",
        notificationsEnabled: false
    }
    public readonly newPhone = (country: string = CountryCodes.CA): IPhoneCheckin =>
        ({
            contactId: "",
            phoneType: "Phone",
            number: "",
            countryLookupId: country,
            contactPointId: "",
            contactPointType: "Personal",
            extension: "",
            isPreferred: false,
            notificationsEnabled: false
        });

    public readonly newAddress = (country: string = CountryCodes.CA, state: string = "QC"): IAddressCheckin=> ({
        streetAddress: "",
        city: "",
        country,
        state,
        zipCode: "",
        contactId: "",
        contactPointType: "Personal",
        contactPointId: "",
        isPreferred: false,
    });
}
export default new PatientDefault;


// WEBPACK FOOTER //
// ./src/services/Initializer/PatientDefaultInitializer.ts